import {
  CurrencyCodesEnum
} from '@shared/types';
import {
  type OmegaApiResponse
} from '@shared/api';

export enum ChallengeStatusEnum {
  Claimable = 'CLAIMABLE',
  Active = 'ACTIVE',
  Completed = 'COMPLETED'
};

export enum ChallengeTypeEnum {
  User = 'USER',
  Game = 'GAME'
};

export enum ChallengeSpecificationEnum {
  Login = 'LOGIN',
  Bet = 'BET'
};

export enum ChallengeVariantEnum {
  Red = 'RED',
  Blue = 'BLUE',
  Green = 'GREEN',
  Yellow = 'YELLOW',
  DarkBlue = 'DARK_BLUE',
};

export type ChallengeMedia = {
  url: Maybe<Url>;
};

export type Challenge = {
  giftClaimedImage: ChallengeMedia;
  giftUnclaimedImage: ChallengeMedia;
  challengeUUID: UniqueId;
  currency: CurrencyCodesEnum;
  endDate: string;
  percentage: number;
  progress: number;
  specification: ChallengeSpecificationEnum;
  status: ChallengeStatusEnum;
  target: number;
  title: string;
  subTitle: string;
  variant: ChallengeVariantEnum;
  type: ChallengeTypeEnum;
  successMessage: string;
};

export type RedeemChallengeParams = {
  challengeUUID: UniqueId;
};

export type RedeemChallengeData = {
  badgeUUID: UniqueId;
  awardAmount: number;
};